import Link from "next/link";

import { useEffect, useState } from "react";
import useAuth from "../lib/useAuth";

import { useForm } from '@mantine/form';
import { SignIn } from '@clerk/nextjs'
import { useAuth as useClerkAuth } from '@clerk/nextjs'


import {
  TextInput,
  PasswordInput,
  Text,
  Paper,
  Group,
  PaperProps,
  Button,
  Checkbox,
  Stack,
  LoadingOverlay,
} from '@mantine/core';
import Router from "next/router";
import { consoleError } from "../lib/logger";
import { RUSError } from "../lib/definitions";
import exp from "constants";
import SignInForm from "./SignInForm";
/*
type formValues =
{
  email:string;
  name:string;
  password:string;
  rememberMe:boolean;
}
*/
type LogInProps =
{
  redirect? : string,
  defaultEmail?: string,
  title?:string
}

export default function LogInForm(props:  LogInProps) {

  return <SignInForm redirectUrl={props.redirect} signUpIfMissing={false} prompt="Please enter your username or email address" allowUsername={true}/>;
}


/*
export default function LogInForm(props: PaperProps & LogInProps) {
  const form = useForm<formValues>({
    initialValues: {
      email: props.defaultEmail?props.defaultEmail:'',
      name: '',
      password: '',
      rememberMe: true,
    },
  
    validate: {
    },
  });
  


  const {logIn} = useAuth();

  //console.log("Redirect to " + props.redirect);
  const {signedIn} = useClerk();
  const loggedIn = signedIn;

  const [refresh, setRefresh] = useState(0);
  const [working, setWorking] = useState(false);

  useEffect(() =>
  {
    //console.log("Redirect to " + props.redirect);
    //console.log(loggedIn);

    if (loggedIn)
    {
      if (props.redirect !== undefined)
      {
        //console.log("** Redirecting to " + props.redirect);
        Router.push(props.redirect);
      }
    }
  }
  ,[refresh, loggedIn]
  );
  
  async function submitHandler(data : formValues)
  {

    try
    {

      setWorking(true);
      await logIn( data.email, data.password, data.rememberMe);
    }
      catch (e)
      {
        if (e instanceof RUSError)
        {
          form.setFieldError("password", "Invalid username or password");
        }
        else
        {
            consoleError(e);
        }
      }
      finally
      {
        setWorking(false);
        setRefresh(refresh+1);
      }
  }


  return (

    <Paper radius="md" p="xl" withBorder {...props} style={{position:'relative'}}>
      <LoadingOverlay visible={working} overlayProps={{ blur: 2 }} transitionProps={{duration:500}}/>
      <Text size="lg" fw={500} mb="lg">
        {!props.title && "Please log in below."}
        {props.title && props.title}
      </Text>


      <form onSubmit={form.onSubmit((values) => submitHandler(values))}>
        <Stack>

          <TextInput
            required
            label="Email / username"
            placeholder="hello@example.com"
            value={form.values.email}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => form.setFieldValue('email', event.currentTarget.value)}
            error={form.errors.email && 'Invalid email/username'}
          />

          <PasswordInput
            required
            label="Password"
            placeholder="Your password"
            value={form.values.password}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => form.setFieldValue('password', event.currentTarget.value)}
            error={form.errors.password}
            data-sentry-mask
          />

            <Checkbox
              label="Remember me"
              checked={form.values.rememberMe}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => form.setFieldValue('rememberMe', event.currentTarget.checked)}
            />
        </Stack>

        <Group justify="apart" mt="xl">
        
          <Button type="submit">Log in</Button>
          <Text>Forgotten your password? <Link href='/forgot-password'>Click here to reset it.</Link></Text>
        </Group>
      </form>
    </Paper>
  )
}*/